export default {
  borderColor: 'brandOne10',
  borderColorInverse: 'brandOne50',
  closeButtonBorderRadius: 'none',
  popupBorderRadius: 'medium',
  overlayColor: '2, 49, 91, 0.7',
  includeFooterDivider: true,
  buttonVariant: 'secondary',
  styleScrollbars: false,
  closeCtaSize: '40px',
  textColor: 'brandOne20',
  buttonStyle: 'solidPrimaryOutline',
};
